// extracted by mini-css-extract-plugin
export default {"SideMenu":"SideMenu_SideMenu__-uvR6","SideMenu_button":"SideMenu_SideMenu_button__-2iAE","SideMenu_CloseIcon":"SideMenu_SideMenu_CloseIcon__gpBwG"};